module.exports = __webpack_public_path__ + "img/GSK_bg_sm.86510314.png";